import styled, { css } from 'styled-components';
import { getToken } from '@optimus-web/common';
import { List, MewsAvatar } from '@optimus-web/core';
import { MewsBackgroundImage } from '@mews/business-components';
import {
    AVATAR_SIZES,
    COLOR_LIGHT_GRAY,
    COLOR_WHITE,
    FONT_SIZE_LARGE,
} from '../../../components/commander-ui/constants';

export const ProfileContainer = styled.div`
    display: flex;
    height: 100px;
    align-items: center;
    padding: 0 16px;
`;

export const AccountName = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 16px;
    color: ${COLOR_WHITE};
    z-index: 1;
`;

export const UserName = styled.div`
    font-size: ${FONT_SIZE_LARGE};
`;

export const UserAvatarContainer = styled.div`
    z-index: 1;
    display: flex;
    align-items: center;
    ${(props) => props.onClick && `cursor: pointer;`}
`;

export const UserMenuContainer = styled.div`
    border-bottom: 1px solid ${COLOR_LIGHT_GRAY};
`;

export const MenuMewsAvatar = styled(MewsAvatar)`
    min-width: ${getToken('sizing700')}px;
    width: ${getToken('sizing700')}px;
`;

export const ProfileDivider = styled.div`
    border-top: 1px solid ${COLOR_LIGHT_GRAY};
`;

const ProfileBackgroundStyles = css`
    position: relative;
    height: 100px;
    margin: 0px;
`;

export const ProfileBackground = styled.div`
    ${ProfileBackgroundStyles}
    background-color: rgba(0, 0, 0, .75);
`;

export const ProfileImageBackground = styled(MewsBackgroundImage).attrs({ showOverlay: true, sizes: AVATAR_SIZES })`
    ${ProfileBackgroundStyles}
`;

export const VirtualContainer = styled.div`
    height: 200px;
`;

export const ListContainer = styled(List)`
    overflow-y: auto;
    max-height: 250px;
`;
